export default __webpack_public_path__ + "static/media/Time.aa065167.svg";